import { render } from "./ProductCopy.vue?vue&type=template&id=f5bee44a&scoped=true"
import script from "./ProductCopy.js?vue&type=script&lang=js&external"
export * from "./ProductCopy.js?vue&type=script&lang=js&external"

import "./ProductCopy.scss?vue&type=style&index=0&id=f5bee44a&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5bee44a"]])

export default __exports__